import {
  REKAN_BISNIS,
  LEVEL_ID,
  AXI_FROM_ID,
  SET_AXI_DETAIL,
  SET_SNK_PDF,
} from "@/stores/constants";
import {
  getRekanBisnis,
  searchAxi,
  getAxiDetail,
  updateAxiForGalaxi,
  resendEmailGalaxi,
  suksesEmail,
} from "@/services/axi";
import { token } from "@/services/token";
import { getSnkPdf } from "../../services/axi";

export default {
  namespaced: true,
  state: {
    rekanBisnis: [],
    levelId: [],
    axiFromId: [],
    axiRegDetail: "",
    snkPdf: null,
  },
  getters: {
    getRekanBisnis: (state) => state.rekanBisnis,
    getLevelId: (state) => state.levelId,
    getAxiFromId: (state) => state.axiFromId,
    getAxiDetail: (state) => state.axiRegDetail,
    getPdfSnk: (state) => state.snkPdf,
  },
  mutations: {
    [REKAN_BISNIS](state, rekanBisnis) {
      state.rekanBisnis = rekanBisnis;
    },
    [LEVEL_ID](state, levelId) {
      state.levelId = levelId;
    },
    [AXI_FROM_ID](state, axiFromId) {
      state.axiFromId = axiFromId;
    },
    [SET_AXI_DETAIL](state, axiRegDetail) {
      state.axiRegDetail = axiRegDetail;
    },
    [SET_SNK_PDF](state, snkPdf) {
      state.snkPdf = snkPdf;
    },
  },
  actions: {
    async fetchRekanBisnis({ commit }, nomorAxiId) {
      try {
        const result = await getRekanBisnis(nomorAxiId);
        const { data } = result.data;
        commit(REKAN_BISNIS, data);
      } catch (error) {
        throw error;
      }
    },
    async searchAxiFromId({ commit }, nomorAxiId) {
      try {
        let result = await searchAxi(nomorAxiId);
        const { data } = result.data;
        commit(AXI_FROM_ID, data);
      } catch (error) {
        throw error;
      }
    },
    setLevelId({ commit }, arr) {
      try {
        commit(LEVEL_ID, arr);
      } catch (err) {
        throw err;
      }
    },
    async getAxiDetailList({ commit }, profileId) {
      try {
        let result = await getAxiDetail(profileId);
        const { data } = result;
        commit(SET_AXI_DETAIL, data);
      } catch (err) {
        // console.log(err.response);
        return err;
      }
    },

    async updateAxiForGalaxi({ commit }, payload) {
      try {
        const { data } = await updateAxiForGalaxi(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    async resendEmailGalaxi({ commit }, payload) {
      try {
        const { data } = await resendEmailGalaxi(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    async suksesEmail({ commit }, payload) {
      try {
        const { data } = await suksesEmail(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    async fetchSnkPdf({ commit }) {
      try {
        const { data } = await getSnkPdf();
        commit("SET_SNK_PDF", data);
        // return data
      } catch (error) {
        throw error;
      }
    },
  },
};
